"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const MuiTooltipOverrides = {
    MuiTooltip: {
        defaultProps: {
            slotProps: {
                popper: {
                    modifiers: [
                        {
                            name: 'offset',
                            options: {
                                offset: [0, -6],
                            },
                        },
                    ],
                },
            },
        },
        styleOverrides: {
            arrow: ({ theme }) => ({
                color: theme.palette.gray[900],
            }),
            tooltip: ({ theme }) => ({
                backgroundColor: theme.palette.gray[900],
                color: theme.palette.common.white,
                fontWeight: theme.typography.fontWeightMedium,
                fontSize: theme.typography.caption.fontSize,
                lineHeight: theme.typography.caption.lineHeight,
                borderRadius: '4px',
            }),
        },
    },
};
exports.default = MuiTooltipOverrides;
//# sourceMappingURL=MuiTooltipOverrides.js.map